// Helper to convert data to booked by test
export default function convertToBookedByTest(values) {
  // Swap person data so the one having the vaccination is registered as the person
  const bookedByPostData = {
    phone: values.phone,
    first_name: values.details.on_behalf_of.first_name,
    last_name: values.details.on_behalf_of.last_name,
    national_id: values.details.on_behalf_of.national_id,
    details: {
      ...values.details,
      booked_by: {
        relation: values.details.on_behalf_of.relation,
        phone: values.phone,
      },
    },
  }

  // We don't need this anymore
  delete bookedByPostData.details.on_behalf_of

  return bookedByPostData
}
